import { Component, OnDestroy, OnInit } from '@angular/core';
import { DXFService } from '../../services/dxf.service';
import { EbwModalService } from '@ebw-monorepo/modal';
import { I18NService } from '@ebw-monorepo/i18n-translate';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ebw-dxf-map',
  templateUrl: './dxf-map.component.html',
  styleUrls: ['./dxf-map.component.scss']
})
export class DXFMapComponent implements OnInit, OnDestroy {
  dxfTitle: string;
  viewportRatio: number;

  constructor(
    public dxfService: DXFService,
    private ebwModalService: EbwModalService,
    private translateService: I18NService
  ) {}

  ngOnInit(): void {}

  selectAreaClick(): void {
    if (!!this.dxfService.dxfAreaSelected) {
      this.ebwModalService
        .openConfirmModal({
          title: this.translateService.getInstantValue('common.warning'),
          content: this.translateService.getInstantValue('map.export_dxf.geometry_already_selected')
        })
        .afterClosed()
        .subscribe((result) => {
          if (result == true) {
            this.dxfService.selectArea();
          }
        });
    } else {
      this.dxfService.selectArea();
    }
  }

  onSave() {
    this.dxfService.save(this.dxfTitle);
  }

  ngOnDestroy(): void {
    this.dxfTitle = null;
    this.dxfService.closeDXF();
  }
}
